import React, { useState } from "react";
import { Form, Input, Button, Checkbox, message } from "antd";
import "./style.css";
import {
    _error,
    _getToken,
    _setAxios,
    _success,
    checkAccess
} from "../../lib/Helper";

const logoMan = require("../../assets/images/logo-man.png");

const Login = () => {
    const [loadingBtn, setLoadingBtn] = useState(false);

    const checkAuth = async () => {
        if (!_getToken()) {
            _error("topRight", "Access", "Gagal mendapatkan akses");
            return false;
        }

        try {
            const resp = await _setAxios("privilege/access", "GET");

            if (resp.status === true) {
                const profile = resp.data?.data?.profile;
                const tahunAjaran = {
                    ...resp.data.data.tahun_ajaran,
                    id: resp.data.data.tahun_ajaran?.id || 0,
                };

                if (!tahunAjaran?.id) {
                    _error("topRight", "Access", "Tahun ajaran belum aktif atau semester belum aktif");
                    return false;
                }

                localStorage.setItem("persist:tahun_ajaran", JSON.stringify(tahunAjaran));

                let isAllowed = checkAccess(profile)
                if (!isAllowed) {
                    setLoadingBtn(false);
                    return false
                }
                window.location.href = process.env.REACT_APP_BASE_URL
                return true
            
            } else {
                _error("topRight", "Access", "Gagal mendapatkan akses");
                localStorage.clear();
                setLoadingBtn(false);
                return false;
            }
        } catch (err) {
            _error("topRight", "Access", "Terjadi kesalahan saat autentikasi");
            localStorage.clear();
            setLoadingBtn(false);
            return false;
        }
    };

    const onFinish = async (values) => {
        try {
            setLoadingBtn(true);

            if (values.remember) {
                localStorage.setItem("persist:remember", JSON.stringify(values));
            }

            const resp = await _setAxios("login", "POST", values, "data");

            if (resp.status === true) {
                const token = `${resp.data.token_type} ${resp.data.access_token}`;
                localStorage.setItem("persist:auth", token);

                localStorage.setItem("persist:remember", "");
                if (values.remember) {
                    localStorage.setItem("persist:remember", JSON.stringify(values));
                }

                const ok = await checkAuth();
                if (ok) {
                    _success("topRight", "Success", resp.data.message);
                }
            } else {
                setLoadingBtn(false);
                localStorage.clear();
            }
        } catch (error) {
            message.error("Terjadi kesalahan. Silakan coba lagi.");
            console.error(error);
            setLoadingBtn(false);
        }
    };

    return (
        <div className="layout">
            <div className="left-column"></div>
            <div className="right-column">
                <div className="header-content">
                    <img src={logoMan} alt="Logo" className="login-logo" />
                    <div className="login-title">Assalamu'alaikum</div>
                    <div className="login-description">
                        Masukkan email dan password yang terdaftar
                    </div>
                </div>
                <div className="login-container">
                    <Form
                        layout="vertical"
                        name="loginForm"
                        initialValues={{ remember: true }}
                        autoComplete="off"
                        onFinish={onFinish}
                    >
                        <Form.Item
                            label="E-Mail"
                            name="email"
                            rules={[{ required: true, message: "E-Mail wajib diisi" }]}
                        >
                            <Input placeholder="Ex: john.doe@man1gresik.sch.id" />
                        </Form.Item>
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: "Password wajib diisi" }]}
                        >
                            <Input.Password placeholder="Masukkan password" />
                        </Form.Item>
                        <Form.Item name="remember" valuePropName="checked">
                            <Checkbox>Remember me</Checkbox>
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ width: "100%" }}
                                loading={loadingBtn}
                            >
                                Masuk
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
                <div className="login-footer">
                    Madrasah Digital MAN 1 Gresik @{new Date().getFullYear()}
                </div>
            </div>
        </div>
    );
};

export default Login;
